// taken from https://docs.google.com/spreadsheets/d/13WY5UMs8YVFDCQUCYb9iE2PdGXTUN0uwTN9kyRteFlo/edit#gid=1279160079
export const questionUnits = [
	"meter",
	"meter2",
	"meter3",
	"euro",
	"percent",
	"month",
] as const;
export type QuestionUnit = typeof questionUnits[number];
